/**
 * @description axios for fetching data via services
 */
import axios from "axios";
import { apiManagement, ocpApimSubscriptionKey } from "../constants/environmentSettings";

const authenticatedEligibilityApi =  
  axios.create({
    baseURL: apiManagement,
    timeout: 300000, // 5 min
    headers: {
      "Content-type": "application/json",
      accept: "application/json",
      "Ocp-Apim-Subscription-Key": ocpApimSubscriptionKey
    }
  });

export default authenticatedEligibilityApi;